export type ValueOf<T> = T[keyof T]

import { type LanguageMapType } from '@models/entities/languages'
import { type UserPermissionsType } from '@models/entities/permissions'

export type CompanyType = {
  name: string;
  created_date: string;
}

export type UserType = {
  id: number;
  name: string;
  email: string;
  date_joined: string;
  company: CompanyType | null;
  lang: keyof LanguageMapType | null;
  user_permissions?: UserPermissionsType;
  login_mfa?: boolean;
}

export enum UserQueryEnum {
  show_user_info = 'show_user_info',
  user_id = 'user_id'
}
